// src/components/ChargingStation/PaymentMethod.android.tsx
import React from "react";

/**
 * On Android, we use the native Payment Sheet dialog instead of Stripe Elements.
 * This component is never rendered, because on native we handle payment entirely
 * via the hook + CheckoutSection. So we just return null here.
 */
const PaymentMethodAndroid: React.FC = () => {
  return null;
};

export default PaymentMethodAndroid;
